import { Modal, Button, Form, FormProps, Input } from "antd";
import { Col, Row, Table } from "react-bootstrap";
import uploadImage from "../../../../assets/images/uploadImage.png";
import TextArea from "antd/es/input/TextArea";
import { IoIosCheckboxOutline } from "react-icons/io";
import { PiWarningCircle } from "react-icons/pi";

const ReplacementModal = (props: any) => {
  const onFinish: FormProps<any>["onFinish"] = (values) => {
    console.log("Success:", values);
  };
  const onFinishFailed: FormProps<any>["onFinishFailed"] = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <Modal
      title="Replace Sensor"
      open={props?.open}
      onOk={() => props?.close()}
      onCancel={() => props?.close()}
      width={800}
      footer={false}
    >
      <Form
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Row className="d-flex justify-center align-items-center">
          <Col md={4}>
            <div onClick={()=>{console.log('here')}} className="image-container-modal">
              <img
                className="image-modal"
                src={uploadImage}
                alt="upload photo image"
              />
            </div>
          </Col>
          <Col md={8}>
            <Row>
              <Col>
                <div>
                  <text className="replace-modal-text2">Twin ID</text>
                  <Form.Item
                    name="twin_id"
                    rules={[
                      {
                        required: true,
                        message: "Please input Twin ID!",
                      },
                    ]}
                  >
                    <Input className="replacement-modal-input" placeholder="S-90240-00039" />
                  </Form.Item>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div>
                  <text className="replace-modal-text2">Display Name</text>
                  <Form.Item
                    name="display_name"
                    rules={[
                      {
                        required: true,
                        message: "Please input your display name!",
                      },
                    ]}
                  >
                    <Input className="replacement-modal-input" placeholder="Speed Log" />
                  </Form.Item>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div>
                  <text className="replace-modal-text2">Kind</text>
                  <Form.Item
                    name="username"
                    rules={[
                      {
                        required: true,
                        message: "Please input the kind!",
                      },
                    ]}
                  >
                    <Input className="replacement-modal-input" placeholder="Sensor" />
                  </Form.Item>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col>
            <div>
              <div className="d-flex justify-content-between mb-2">
                <text className="replace-modal-text2">Description</text>
                <div className="d-flex gap-1 align-items-center">
                  <IoIosCheckboxOutline />
                  <text className="replace-modal-text3">
                    Use previous sensor information
                  </text>
                </div>
              </div>

              <Form.Item
                name="description"
                rules={[
                  {
                    required: true,
                    message: "Please input the description!",
                  },
                ]}
              >
                <TextArea
                    className="replacement-modal-input"
                  placeholder="Provide a detailed description about the new sensor or use the old sensor info"
                  style={{ height: 120 }}
                />
              </Form.Item>
            </div>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col md={8} className="d-flex gap-2 align-items-center">
            <div className="warinig-icon-container">
              <PiWarningCircle className="warning-icon" />
            </div>
            <text className="replace-modal-text1">
              Please provide the necessary details about the new replacement,
              and the remaining information will be taken from the previous
              sensor.
            </text>
          </Col>
          <Col md={4} className=" d-flex align-items-end">
            <Button className="w-100" type="primary">
              Replace Sensor
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default ReplacementModal;
